import rockwellLogo from "@/assets/partners/rockwell.png";
import bradenFellmanLogo from "@/assets/partners/bradenfellman.png";
import articleLogo from "@/assets/partners/article.svg";
import featherLogo from "@/assets/partners/feather.png";

/**
 * Bundled partner-logo registry, keyed by the backend tenant
 * `branding.partner_key`. Consumed by `CoBrandedHeader`.
 *
 * Lives in its own module rather than inside the component so it can be tested
 * directly — exporting it from `CoBrandedHeader.tsx` trips
 * `react-refresh/only-export-components`, and the rule is right: a component
 * file that also exports constants breaks fast refresh.
 *
 * To add a tenant: drop the asset at `src/assets/partners/<slug>.png` and add
 * the entry here. The key must match `organizations.config.branding.partner_key`
 * **exactly** — an unknown key renders DigaVouch-only chrome rather than
 * erroring, so a typo is indistinguishable from "not branded yet" and nobody
 * notices. `partnerLogos.test.ts` pins the key set for that
 * reason.
 *
 * Use the **dark** variant of a mark: the logo renders inside a white pill
 * (`bg-white rounded-md` in CoBrandedHeader), so a white-on-transparent wordmark
 * is invisible there.
 *
 * Phase C MVP is bundled-asset only; `tenant.branding.logo_url` is
 * intentionally ignored for now.
 */
export const PARTNER_LOGOS: Record<string, string> = {
  article: articleLogo,
  // A real tenant in every environment, so listed in production too. The
  // asset is a horizontal lockup (mark and wordmark) sized for the header.
  feather: featherLogo,
  rockwell: rockwellLogo,
  bradenfellman: bradenFellmanLogo,
};
